import { DialogDataTableMaskPanel } from "./maskpanel/DialogDataTableMaskPanel.ts";
import { FramebusChildMaskPanel } from "./maskpanel/FramebusChildMaskPanel.ts";
import { FramebusTopMaskPanel } from "./maskpanel/FramebusTopMaskPanel.ts";

export { initDefaultPlaceholderMask, PlaceholderMask } from "./PlaceholderMask.ts";

export interface MaskPanel {
  DialogDataTableMaskPanel: typeof DialogDataTableMaskPanel;
  FramebusChildMaskPanel: typeof FramebusChildMaskPanel;
  FramebusTopMaskPanel: typeof FramebusTopMaskPanel;
}

export const MaskPanel: MaskPanel = {
  DialogDataTableMaskPanel: DialogDataTableMaskPanel,
  FramebusChildMaskPanel: FramebusChildMaskPanel,
  FramebusTopMaskPanel: FramebusTopMaskPanel,
};
